import { lazy } from "react"
import { RouteProps } from "../features.types"

const CartController = lazy(() => import("./cart-controller"))
const CartHome = lazy(() => import("./cart"))
// define route constant
export const CART_ROUTE = "cart"

//define routes
export const Cart: RouteProps[] = [
  {
    path: `${CART_ROUTE}`,
    Component: CartController,
    children: [
      {
        index: true,
        Component: CartHome,
      },
    ],
  },
]
